import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import { PaginaRescisao } from 'src/paginas/rescisao'
import { PaginaTermoRescisao } from 'src/paginas/rescisao/termo'

export const RotasRescisaoAluno = {
  Wizard: '/rescisao/wizard',
  Termo: '/rescisao/termo'
}

/**
 * Rotas do fluxo do aluno — acessadas pelo LINK do e-mail (com login), sem
 * entrada de menu. Espelha o padrão de `rotas/reingresso.tsx`.
 */
export const RescisaoRotas: React.FC = () => {
  return (
    <Switch>
      <Route path={`${RotasRescisaoAluno.Wizard}/:id`}>
        <PaginaRescisao />
      </Route>
      <Route path={`${RotasRescisaoAluno.Termo}/:id`}>
        <PaginaTermoRescisao />
      </Route>
      <Route path="*">
        <Redirect to="/" />
      </Route>
    </Switch>
  )
}
